import FalconerAdmin from "./images/Falconer_Admin.png";
import FalconerCode from "./images/Falconer_Code.png";
import FalconerHR from "./images/Falconer_HR.png";
import FalconerHome from "./images/Falconer_Home.png";
import FalconerLogo from "./images/Falconer_Logo.png";
import FalconerProduct from "./images/Falconer_Product.png";

import Transcribia from "./images/Trancscribia.png";
import TranscribiaCode from "./images/Transcribia_Code.png";

import FlipCard from "./images/FGPT_Card.png";
import FlipHistory from "./images/FGPT_History.png";
import FlipLogin from "./images/FGPT_Login.png";
import FlipTopic from "./images/FGPT_Topic.png";

import JC from "./images/JC_Home.png";

import ReactCode from "./images/ReactCode.png";

import ComixLibrary from "./images/ComixLibrary.jpg";
import ComixBook from "./images/ComixBook.jpeg";

import IconTs from "./images/Ts.png";
import IconAngular from "./images/Angular.png";
import IconFigma from "./images/Figma.png";
import IconHtml from "./images/HTML.png";
import IconInsta from "./images/Insta.png";
import IconJava from "./images/Java.png";
import IconJs from "./images/Js.png";
import IconLinkedIn from "./images/LinkedIn.png";
import IconNode from "./images/Node.png";
import IconNpm from "./images/Npm.png";
import IconPython from "./images/Python.png";
import IconReact from "./images/React.png";
import IconSql from "./images/Sql.png";
import IconTf from "./images/Tf.png";
import IconVs from "./images/Vs.png";
import IconRIT from "./images/rit-logo.png";

import IconC from "./images/c.png";
import IconCSharp from "./images/c#.png";
import IconCPlus from "./images/c++.png";
import IconCSS from "./images/css.png";
import IconGithub from "./images/github.png";
import IconGitlab from "./images/gitlab.png";
import IconMongo from "./images/mongodb.png";
import IconStripe from "./images/stripe.png";

import AboutImage1 from "./images/about_images/image1.jpg";
import AboutImage2 from "./images/about_images/image2.jpg";
import AboutImage3 from "./images/about_images/image3.jpg";
import AboutImage4 from "./images/about_images/image4.jpg";
import AboutImage5 from "./images/about_images/image5.jpg";
import AboutImage6 from "./images/about_images/image6.jpg";
import AboutImage7 from "./images/about_images/image7.jpg";
import AboutImage8 from "./images/about_images/image8.jpg";
import AboutImage9 from "./images/about_images/image9.jpg";
import AboutImage10 from "./images/about_images/image10.jpg";
import AboutImage11 from "./images/about_images/image11.jpg";
import AboutImage12 from "./images/about_images/image12.jpg";
import AboutImage13 from "./images/about_images/image13.jpg";
import AboutImage14 from "./images/about_images/image14.jpg";
import AboutImage15 from "./images/about_images/image15.jpg";
import AboutImage16 from "./images/about_images/image16.jpg";
import AboutImage17 from "./images/about_images/image17.jpg";
import AboutImage18 from "./images/about_images/image18.jpg";
import AboutImage19 from "./images/about_images/image19.jpg";
import AboutImage20 from "./images/about_images/image20.jpg";
import AboutImage21 from "./images/about_images/image21.jpg";
import AboutImage22 from "./images/about_images/image22.jpg";
import AboutImage23 from "./images/about_images/image23.jpg";
import AboutImage24 from "./images/about_images/image24.jpg";
import AboutImage25 from "./images/about_images/image25.jpg";
import AboutImage26 from "./images/about_images/image26.jpg";
import AboutImage27 from "./images/about_images/image27.jpg";
import AboutImage28 from "./images/about_images/image28.jpg";
import AboutImage29 from "./images/about_images/image29.jpg";

export const IMAGES = {
  FalconerAdmin,
  FalconerCode,
  FalconerHR,
  FalconerHome,
  FalconerLogo,
  FalconerProduct,

  Transcribia,
  TranscribiaCode,

  FlipCard,
  FlipHistory,
  FlipLogin,
  FlipTopic,

  JC,

  ReactCode,

  ComixLibrary,
  ComixBook,

  IconTs,
  IconAngular,
  IconFigma,
  IconHtml,
  IconInsta,
  IconJava,
  IconJs,
  IconLinkedIn,
  IconNode,
  IconNpm,
  IconPython,
  IconReact,
  IconSql,
  IconTf,
  IconVs,
  IconRIT,
  IconC,
  IconCSharp,
  IconCPlus,
  IconCSS,
  IconGithub,
  IconGitlab,
  IconMongo,
  IconStripe,

  AboutImage1,
  AboutImage2,
  AboutImage3,
  AboutImage4,
  AboutImage5,
  AboutImage6,
  AboutImage7,
  AboutImage8,
  AboutImage9,
  AboutImage10,
  AboutImage11,
  AboutImage12,
  AboutImage13,
  AboutImage14,
  AboutImage15,
  AboutImage16,
  AboutImage17,
  AboutImage18,
  AboutImage19,
  AboutImage20,
  AboutImage21,
  AboutImage22,
  AboutImage23,
  AboutImage24,
  AboutImage25,
  AboutImage26,
  AboutImage27,
  AboutImage28,
  AboutImage29,
};
